export const GoogleKeys = {
    GOOGLE_MAPS_API_KEY:process.env.REACT_APP_GOOGLE_MAPS_API_KEY
}